import React from 'react';
import useIsMobile from '@/hooks/useIsMobile';
import Desktop from './desktop';
import Mobile from './mobile';
import useComponent from './useComponent';

const ShopReportPage = () => {
  const isMobile = useIsMobile(992);
  const viewModel = useComponent();

  if (isMobile) {
    return <Mobile viewModel={viewModel} />;
  }

  return <Desktop viewModel={viewModel} />;
};

export default ShopReportPage;
